/* Leil — upsell / cross-sell engine
   - loads recommendation strips via the Section Rendering API
   - quick-add with a compact colour/size chooser for multi-variant products
   - post-add-to-cart popup that cross-sells matching pieces          */
(function () {
  var R = window.routes || {};
  var RECS_URL = R.product_recommendations_url || '/recommendations/products';
  var ADD_URL = R.cart_add_url || '/cart/add';
  var CART_URL = R.cart_url || '/cart';

  var IS_AR =
    document.documentElement.getAttribute('dir') === 'rtl' ||
    (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0;

  function t(ar, en) {
    return IS_AR ? ar : en;
  }

  /* ---------------- recommendation strips ---------------- */

  function loadBlock(block) {
    var pid = block.getAttribute('data-product-id');
    if (!pid || block.dataset.upLoaded) return;
    block.dataset.upLoaded = '1';

    var url =
      RECS_URL +
      '?section_id=leil-recs&product_id=' +
      encodeURIComponent(pid) +
      '&limit=' +
      encodeURIComponent(block.getAttribute('data-limit') || 4) +
      '&intent=' +
      encodeURIComponent(block.getAttribute('data-intent') || 'complementary');

    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var row = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-up-row]');
        // 'complementary' is curated in admin and is often empty — fall back to 'related'
        if (!row && block.getAttribute('data-intent') === 'complementary') {
          block.setAttribute('data-intent', 'related');
          delete block.dataset.upLoaded;
          loadBlock(block);
          return;
        }
        if (!row) return;
        block.querySelector('[data-up-slot]').appendChild(row);
        block.hidden = false;
      })
      .catch(function () {});
  }

  function loadAll(scope) {
    (scope || document).querySelectorAll('[data-up-block]').forEach(loadBlock);
  }

  /* ---------------- cart helpers ---------------- */

  function addToCart(variantId, qty) {
    return fetch(ADD_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(qty || 1) }] })
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw new Error(d.description || d.message || 'error');
        return d;
      });
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('leil:cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  /* ---------------- variant chooser ---------------- */

  function parseAttr(btn, name) {
    try {
      return JSON.parse(btn.getAttribute(name) || '[]');
    } catch (e) {
      return [];
    }
  }

  function openChooser(btn) {
    var variants = parseAttr(btn, 'data-variants');
    var options = parseAttr(btn, 'data-options');
    var chosen = options.map(function (o) {
      return o.v[0];
    });

    var wrap = document.createElement('div');
    wrap.className = 'leil-up__modal';
    wrap.innerHTML =
      '<div class="leil-up__modal-box" role="dialog" aria-modal="true">' +
      '<button type="button" class="leil-up__close" aria-label="' + t('إغلاق', 'Close') + '">&times;</button>' +
      '<div class="leil-up__modal-title">' + btn.getAttribute('data-title') + '</div>' +
      '<div class="leil-up__opts"></div>' +
      '<button type="button" class="leil-btn leil-btn--fill leil-up__confirm">' +
      t('أضيفي للحقيبة', 'Add to Bag') +
      '</button>' +
      '</div>';

    var optsEl = wrap.querySelector('.leil-up__opts');
    var confirm = wrap.querySelector('.leil-up__confirm');

    function match() {
      return variants.find(function (v) {
        return v.o.join(' / ') === chosen.join(' / ');
      });
    }

    function sync() {
      var v = match();
      confirm.disabled = !v || !v.a;
      confirm.textContent = !v
        ? t('غير متاح', 'Unavailable')
        : v.a
        ? t('أضيفي للحقيبة', 'Add to Bag')
        : t('نفد المخزون', 'Sold out');
    }

    options.forEach(function (o, i) {
      var g = document.createElement('div');
      g.className = 'leil-up__optgroup';
      g.innerHTML = '<div class="leil-up__optlabel">' + o.n + '</div>';
      var row = document.createElement('div');
      row.className = 'leil-up__optrow';
      o.v.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = val;
        b.className = val === chosen[i] ? 'is-active' : '';
        b.addEventListener('click', function () {
          chosen[i] = val;
          row.querySelectorAll('button').forEach(function (x) {
            x.classList.remove('is-active');
          });
          b.classList.add('is-active');
          sync();
        });
        row.appendChild(b);
      });
      g.appendChild(row);
      optsEl.appendChild(g);
    });
    sync();

    function close() {
      wrap.remove();
    }
    wrap.querySelector('.leil-up__close').addEventListener('click', close);
    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) close();
    });

    confirm.addEventListener('click', function () {
      var v = match();
      if (!v) return;
      confirm.disabled = true;
      confirm.textContent = t('جاري الإضافة…', 'Adding…');
      addToCart(v.id, 1)
        .then(function () {
          close();
          afterAdd(btn);
        })
        .catch(function (err) {
          confirm.disabled = false;
          confirm.textContent = t('حصلت مشكلة، جرّبي تاني', 'Something went wrong');
        });
    });

    document.body.appendChild(wrap);
  }

  /* ---------------- post-add popup ---------------- */

  // opts: {title, img, id} — or a [data-up-add] button to read them from
  function afterAdd(opts) {
    refreshCartCount();

    // On the cart page the list itself must reflect the new item.
    if (location.pathname.indexOf('/cart') === 0) {
      location.reload();
      return;
    }

    if (opts && opts.getAttribute) {
      opts = {
        title: opts.getAttribute('data-title'),
        img: opts.getAttribute('data-img'),
        id: opts.getAttribute('data-rec-id')
      };
    }
    opts = opts || {};
    var title = opts.title || '';
    var img = opts.img || '';
    var pid = opts.id || '';

    var wrap = document.createElement('div');
    wrap.className = 'leil-up__modal';
    wrap.innerHTML =
      '<div class="leil-up__modal-box leil-up__added" role="dialog" aria-modal="true">' +
      '<button type="button" class="leil-up__close" aria-label="' + t('إغلاق', 'Close') + '">&times;</button>' +
      '<div class="leil-up__added-head">' +
      '<span class="leil-up__tick">✓</span>' +
      '<div><div class="leil-up__added-msg">' + t('تمت الإضافة للحقيبة', 'Added to your bag') + '</div>' +
      (title ? '<div class="leil-up__added-name">' + title + '</div>' : '') +
      '</div>' +
      (img ? '<img class="leil-up__added-img" src="' + img + '" alt="">' : '') +
      '</div>' +
      '<div class="leil-up__added-recs"></div>' +
      '<div class="leil-up__added-actions">' +
      '<button type="button" class="leil-btn leil-up__cont">' + t('متابعة التسوق', 'Keep shopping') + '</button>' +
      '<a class="leil-btn leil-btn--fill" href="' + CART_URL + '">' + t('إتمام الطلب', 'Checkout') + '</a>' +
      '</div>' +
      '</div>';

    function close() {
      wrap.remove();
    }
    wrap.querySelector('.leil-up__close').addEventListener('click', close);
    wrap.querySelector('.leil-up__cont').addEventListener('click', close);
    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) close();
    });

    document.body.appendChild(wrap);

    if (pid) {
      var slot = wrap.querySelector('.leil-up__added-recs');
      slot.innerHTML =
        '<div class="leil-up leil-up--compact" data-up-block data-product-id="' +
        pid +
        '" data-intent="complementary" data-limit="3" hidden>' +
        '<div class="leil-up__head"><h3 class="leil-up__title">' +
        t('يناسبه كمان', 'Goes well with it') +
        '</h3></div><div data-up-slot></div></div>';
      loadAll(slot);
    }
  }

  /* ---------------- wiring ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-up-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variants = parseAttr(btn, 'data-variants');
    var buyable = variants.filter(function (v) {
      return v.a;
    });

    if (variants.length === 1) {
      if (!variants[0].a) return;
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = t('جاري…', 'Adding…');
      addToCart(variants[0].id, 1)
        .then(function () {
          btn.textContent = t('تمت ✓', 'Added ✓');
          afterAdd(btn);
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = label;
          }, 1800);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
      return;
    }

    if (!buyable.length) return;
    openChooser(btn);
  });

  if (document.readyState !== 'loading') loadAll();
  else document.addEventListener('DOMContentLoaded', function () { loadAll(); });

  window.leilUpsell = { load: loadAll, afterAdd: afterAdd, addToCart: addToCart };
})();
